"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const scrollDepthTriggerInputs = [
  {
    name: "eventName",
    type: "string",
    defaultValue: "content_reached",
    hideFromUI: true,
  },
  {
    name: "shouldAvoidMultipleTriggers",
    type: "boolean",
    helperText:
      "If enabled, the event will be triggered only once per page load. Be aware that enabling this option will prevent the event from being triggered again even if the user scrolls up and down multiple times. And event handlers relying on this could be loaded later and miss the event trigger.",
    defaultValue: false,
  },
] as const satisfies Inputs;

export const ScrollDepthTriggerComponent: RegisteredComponent = {
  name: "ScrollDepthTrigger",
  component: dynamic(async () =>
    withValidation(
      scrollDepthTriggerInputs,
      (await import("./ScrollDepthTrigger")).ScrollDepthTrigger,
      "ScrollDepthTrigger"
    )
  ),
  inputs: scrollDepthTriggerInputs,
};
